import './fusioneast/style';
import FormStructure from './fusioneast/form_structure';

export default FormStructure;